module.exports = __webpack_public_path__ + "img/img_example_3.6281fb86.png";